import axiosJsonpPro from 'axios-jsonp-pro'

export const commonService = {
  getZipAddress,
}

async function getZipAddress(params) {
  let idx = params?.currentPage? params.currentPage : 1;
  return await axiosJsonpPro.jsonp(
    'https://www.juso.go.kr/addrlink/addrLinkApiJsonp.do?keyword=' + params.keyword +
    '&confmKey=' + params.confmKey +
    '&resultType=json' +
    '&currentPage=' + idx +
    '&countPerPage=20'
  )
}
